export interface FabricProcessingFabric {
  id: string;
  productId: string;
  productKey: string;
  productDescription: string;
  processProductId: string;
  processProductKey: string;
  processProductDescription: string;
}
